<template>
  <div>
    <pc-header></pc-header>
    <div class="header-wrap">
      <img src="../../../assets/images/news/news-head-bg.png" />
    </div>

    <div class="content-wrap">
      <div class="title" style="text-align: center;">关于降低银行卡刷卡手续费的通知</div>
      <div class="time" style="text-align: center;">
        时间：&nbsp;&nbsp;2021-09-29
      </div>
      <div class="news_details_container">
        <p>尊敬的各位商户：</p>
        <p style="text-indent: 2em;">为优化营商环境，降低商户的经营成本，积极响应四部委的对降低小微企业和个体工商户支付手续费的要求，以及中国支付清算协会的倡议，我公司决定自2021年9月30日起至2024年9月29日对符合标准的商户施行降低银行卡刷卡手续费的优惠政策，具体如下：</p>
        <p style="text-indent: 2em;">我公司对符合条件的小微企业、个体工商户以及其他类型的标准类商户借记卡线下消费交易，施行收单交易手续费费9折、封顶不变；优惠类商户继续维持原来的7.8折优惠，不作调整。</p>
        <p style="text-indent: 2em;">活动期间如有问题请拨打我公司客服热线4006686689。</p>
        <p>&nbsp;</p>
        <p style="text-align: right;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;北京海科融通支付服务有限公司</p>
        <p style="text-align: right;">2021年9月29日</p>
      </div>
    </div>

    <pc-footer></pc-footer>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {}
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.header-wrap {
  // margin-top: -60px;
}
img {
  width: 100%;
  object-fit: cover;
}

.content-wrap {
  padding-top: 50px;
  padding-bottom: 50px;
  width: 900px;
  margin: 0 auto;
  .title {
    font-size: 32px;
    font-weight: bold;
    line-height: 38px;
    color: #000000;
    opacity: 0.85;
  }
  .time {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: #a8a8a8;
    margin-top: 15px;
  }
  .news_details_container {
    // border: 1px solid #dad5cf;
    color: #000000;
    border-left: none;
    border-right: none;
    padding: 22px 0px 40px;
  }
  .news_details_container p {
    font-size: 16px;
    line-height: 30px;
    padding: 20px 0;
  }
}
</style>